import React from 'react';

import * as S from './styles';
import { STATIC_URL } from '../../constant';
import { useHeader } from './hooks';

interface HeaderProps {}

const Header: React.FC<HeaderProps> = () => {
  const { member, showMenu, toggleMenu, handleLogout } = useHeader();

  return (
    <S.Header>
      <S.DesktopLink to="/" onClick={() => {
              window.location.href = "/";
            }}>
        <S.Logo src={STATIC_URL.LOGO} alt="Logo"></S.Logo>
      </S.DesktopLink>
      <S.MobileLink to="/">
        <S.MobileLogo src={STATIC_URL.LOGO_WITHOUT_TEXT} alt="Mobile Logo" />
      </S.MobileLink>
      <S.DesktopButtons>
        <S.DesktopLink to="/about">
          <S.Button>소개</S.Button>
        </S.DesktopLink>
        <S.DesktopLink to="/activity">
          <S.Button>활동</S.Button>
        </S.DesktopLink>
      </S.DesktopButtons>
    </S.Header>
  );
};

export default Header;
